(function () {
  'use strict';

  var addonVariantCache  = {};
  var activeSwatchTrigger = null;

  function getRowVipRate(row) {
    if (window.rhGetVipRate && row && row.dataset.productUrl) {
      return window.rhGetVipRate({ url: row.dataset.productUrl });
    }
    return 0.8;
  }

  var RHCollectionProducts = function () {

    function applyPresets() {
      document.querySelectorAll('.rh-product-row[data-presets]').forEach(function (row) {
        var presets;
        try { presets = JSON.parse(row.dataset.presets); } catch (e) { return; }

        Object.keys(presets).forEach(function (key) {
          if (key === 'qty') {
            var qtySelect = row.querySelector('select[name="quantity"]');
            if (qtySelect) qtySelect.value = String(presets[key]);
            return;
          }
          var sel = row.querySelector('[data-option-name="' + key + '"], [data-custom-option="' + key + '"]');
          var actualValue = presets[key];
          if (sel) {
            sel.value = presets[key];
            if (sel.tagName === 'SELECT' && !sel.value) {
              var firstOpt = sel.querySelector('option:not([disabled]):not([hidden])');
              if (firstOpt) { sel.value = firstOpt.value; actualValue = firstOpt.value; }
            }
          }

          // Update swatch trigger button display if this option has one
          var trigger = row.querySelector('.rh-swatch-trigger[data-option-name="' + key + '"]');
          if (trigger) {
            var swatchData = [];
            try { swatchData = JSON.parse(trigger.dataset.swatchValues || '[]'); } catch (e) {}
            var match = swatchData.find(function (s) { return s.value === actualValue; });
            var swatchEl = trigger.querySelector('.rh-swatch-trigger__swatch');
            var labelEl  = trigger.querySelector('.rh-swatch-trigger__label');
            if (match && match.img && swatchEl) {
              swatchEl.style.backgroundImage = 'url(' + match.img + ')';
              swatchEl.removeAttribute('hidden');
            }
            if (labelEl) labelEl.textContent = actualValue;
          }
        });

        // Fire change on the first variant select to trigger variant lookup + price update
        var firstVariantSel = row.querySelector('select[data-option]');
        if (firstVariantSel) firstVariantSel.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // For products with only a default variant (hidden input pre-filled), show SKU + total on load
      document.querySelectorAll('.rh-product-row').forEach(function (row) {
        var form        = row.querySelector('.rh-product-row__form');
        var hiddenInput = form && form.querySelector('.js-product-card-variant-input');
        if (hiddenInput && hiddenInput.value) {
          updateVariant(row, form);
          updateTotal(row, form);
        }
      });
    }

    function syncSwatchTriggerHeights() {
      var ref = document.querySelector('.rh-product-row__select:not(.rh-swatch-hidden-select)');
      if (!ref) return;
      var h = ref.offsetHeight;
      if (!h) return;
      document.querySelectorAll('.rh-swatch-trigger').forEach(function (t) {
        t.style.height = h + 'px';
      });
    }

    function init() {
      // Store original images so we can reset when no variant image exists
      document.querySelectorAll('.rh-product-row__image').forEach(function (img) {
        img.dataset.originalSrc = img.src;
      });
      document.querySelectorAll('.rh-product-row__image-btn').forEach(function (btn) {
        btn.dataset.originalLightboxSrc = btn.dataset.lightboxSrc || '';
        btn.dataset.originalLightboxAlt = btn.dataset.lightboxAlt || '';
      });

      document.addEventListener('change', onSelectChange);
      document.addEventListener('submit', onFormSubmit);
      document.addEventListener('submit', onAskFormSubmit);
      document.addEventListener('click', onAddAllClick);
      document.addEventListener('click', onImageClick);
      document.addEventListener('click', onInfoTriggerClick);
      document.addEventListener('click', onSwatchTriggerClick);
      document.addEventListener('click', onSwatchItemClick);
      document.addEventListener('click', onModalClose);
      document.addEventListener('keydown', onKeyDown);
      applyPresets();
      syncSwatchTriggerHeights();
    }

    // -------------------------------------------------------------------------
    // Variant / price / total logic
    // -------------------------------------------------------------------------

    function onSelectChange(e) {
      var select = e.target;
      if (!select.matches) return;

      var isVariantSelect = select.matches('.rh-product-row select[data-option]');
      var isQtySelect     = select.matches('.rh-product-row select[name="quantity"]');
      var isCustomSelect  = select.matches('.rh-product-row .rh-custom-option__select');
      if (!isVariantSelect && !isQtySelect && !isCustomSelect) return;

      var row  = select.closest('.rh-product-row');
      var form = row && row.querySelector('.rh-product-row__form');
      if (!row || !form) return;

      if (isVariantSelect) {
        updateVariant(row, form);
        updateVariantImage(row, form);
      }

      updateTotal(row, form);
      updateOrderTotal(select.closest('.rh-collection'));
    }

    function getCustomOptionAddonCents(form) {
      var addon = 0;
      Array.from(form.querySelectorAll('.rh-custom-option__select')).forEach(function (sel) {
        var val = sel.value || '';
        var plus  = val.match(/\(\+\$(\d[\d,]*)\)/);
        var minus = val.match(/\(-\$(\d[\d,]*)\)/);
        var bare  = val.match(/\(\$(\d[\d,]*)\)/);
        if (plus)  addon += Math.round(parseFloat(plus[1].replace(/,/g, ''))  * 100);
        if (minus) addon -= Math.round(parseFloat(minus[1].replace(/,/g, '')) * 100);
        if (bare && !plus && !minus) addon += Math.round(parseFloat(bare[1].replace(/,/g, '')) * 100);
      });
      return addon;
    }

    function updateVariant(row, form) {
      var productScriptEl = form.querySelector('.js-product-card-product');
      if (!productScriptEl) return;

      var productData;
      try { productData = JSON.parse(productScriptEl.textContent); } catch (err) { return; }

      var hiddenInput = form.querySelector('.js-product-card-variant-input');

      // Only consider real variant options (option1/2/3), not custom add-on selects (custom-*)
      var optionSelects = Array.from(form.querySelectorAll('select[data-option]')).filter(function (s) {
        return !s.dataset.option.startsWith('custom-');
      });

      // Products with no variant options (only custom metafield options) — use the default variant
      if (optionSelects.length === 0) {
        var defaultVariant = productData && productData.variants && productData.variants[0];
        if (hiddenInput && defaultVariant) hiddenInput.value = defaultVariant.id;
        if (defaultVariant) {
          var centsMapElDef = row.querySelector('.rh-variant-cents');
          if (centsMapElDef) {
            try {
              var centsMapDef = JSON.parse(centsMapElDef.textContent);
              var regularCentsDef = centsMapDef[String(defaultVariant.id)];
              if (regularCentsDef) {
                regularCentsDef += getCustomOptionAddonCents(form);
                var memberCentsDef = Math.round(regularCentsDef * getRowVipRate(row));
                var priceElDef = row.querySelector('.rh-product-row__price');
                if (priceElDef) {
                  priceElDef.innerHTML =
                    '<span class="rh-product-row__price-member">' + formatMoney(memberCentsDef) + ' <span class="rh-product-row__price-tag">VIP</span></span>' +
                    '<span class="rh-product-row__price-divider"> / </span>' +
                    '<span class="rh-product-row__price-regular">' + formatMoney(regularCentsDef) + ' <span class="rh-product-row__price-tag">Regular</span></span>';
                }
              }
            } catch (err) {}
          }
          var skuMapElDef = row.querySelector('.rh-variant-skus');
          if (skuMapElDef) {
            try {
              var skuMapDef = JSON.parse(skuMapElDef.textContent);
              var skuValDef = skuMapDef[String(defaultVariant.id)];
              var skuElDef = row.querySelector('.rh-product-row__sku');
              if (skuElDef) skuElDef.textContent = skuValDef ? 'SKU-' + skuValDef : '';
            } catch (err) {}
          }
        }
        return;
      }

      var allSelected   = optionSelects.every(function (s) { return s.value; });

      if (!allSelected) {
        if (hiddenInput) { hiddenInput.value = ''; }
        var skuElClear = row.querySelector('.rh-product-row__sku');
        if (skuElClear) skuElClear.textContent = '';
        hideTotal(row);
        return;
      }

      var values  = optionSelects.map(function (s) { return s.value; });
      var variant = null;
      if (productData && productData.variants) {
        variant = productData.variants.find(function (v) {
          var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
          return opts.every(function (opt, i) { return values[i] === opt; });
        }) || null;
      }

      if (hiddenInput) hiddenInput.value = variant ? variant.id : '';
      if (!variant) {
        var skuElNoMatch = row.querySelector('.rh-product-row__sku');
        if (skuElNoMatch) skuElNoMatch.textContent = '';
      }

      var priceEl = row.querySelector('.rh-product-row__price');
      if (priceEl && variant) {
        var centsMapEl = row.querySelector('.rh-variant-cents');
        if (centsMapEl) {
          try {
            var centsMap    = JSON.parse(centsMapEl.textContent);
            var regularCents = centsMap[String(variant.id)];
            if (regularCents) {
              regularCents += getCustomOptionAddonCents(form);
              var memberCents = Math.round(regularCents * getRowVipRate(row));
              priceEl.innerHTML =
                '<span class="rh-product-row__price-member">' + formatMoney(memberCents) + ' <span class="rh-product-row__price-tag">VIP</span></span>' +
                '<span class="rh-product-row__price-divider"> / </span>' +
                '<span class="rh-product-row__price-regular">' + formatMoney(regularCents) + ' <span class="rh-product-row__price-tag">Regular</span></span>';
            }
          } catch (err) {}
        }
      }

      var skuEl = row.querySelector('.rh-product-row__sku');
      if (skuEl && variant) {
        var skuMapEl = row.querySelector('.rh-variant-skus');
        if (skuMapEl) {
          try {
            var skuMap = JSON.parse(skuMapEl.textContent);
            var skuVal = skuMap[String(variant.id)];
            skuEl.textContent = skuVal ? 'SKU-' + skuVal : '';
          } catch (err) {}
        }
      }

    }

    function updateVariantImage(row, form) {
      var productScriptEl = form.querySelector('.js-product-card-product');
      if (!productScriptEl) return;
      var productData;
      try { productData = JSON.parse(productScriptEl.textContent); } catch (err) { return; }
      if (!productData || !productData.variants) return;

      var optionSelects = Array.from(form.querySelectorAll('select[data-option]')).filter(function (s) {
        return !s.dataset.option.startsWith('custom-');
      });
      // Only consider options that have a value selected
      var selectedValues = optionSelects.map(function (s) { return s.value || null; });

      // Find the first variant that matches all selected options and has an image
      var matchedVariant = null;
      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        var opts = [v.option1, v.option2, v.option3];
        var matches = true;
        for (var j = 0; j < selectedValues.length; j++) {
          if (selectedValues[j] !== null && opts[j] !== selectedValues[j]) {
            matches = false;
            break;
          }
        }
        if (matches && v.featured_image && v.featured_image.src) {
          matchedVariant = v;
          break;
        }
      }

      var imgEl  = row.querySelector('.rh-product-row__image');
      var imgBtn = row.querySelector('.rh-product-row__image-btn');
      if (!imgEl) return;

      if (matchedVariant) {
        var vSrc = matchedVariant.featured_image.src;
        imgEl.src = shopifyImgSrc(vSrc, 320);
        if (imgBtn) {
          imgBtn.dataset.lightboxSrc = shopifyImgSrc(vSrc, 1400);
          imgBtn.dataset.lightboxAlt = matchedVariant.featured_image.alt || imgBtn.dataset.originalLightboxAlt || '';
        }
      } else {
        if (imgEl.dataset.originalSrc) imgEl.src = imgEl.dataset.originalSrc;
        if (imgBtn && imgBtn.dataset.originalLightboxSrc) {
          imgBtn.dataset.lightboxSrc = imgBtn.dataset.originalLightboxSrc;
          imgBtn.dataset.lightboxAlt = imgBtn.dataset.originalLightboxAlt || '';
        }
      }
    }

    function shopifyImgSrc(src, width) {
      if (!src) return src;
      return src + (src.includes('?') ? '&' : '?') + 'width=' + width;
    }

    function getCustomOptionAdjustment(form) {
      var adjustment = 0;
      var customSelects = Array.from(form.querySelectorAll('[data-price-rules]'));
      customSelects.forEach(function (select) {
        var value = select.value;
        if (!value) return;
        try {
          var rules = JSON.parse(select.dataset.priceRules);
          var rule  = rules[value];
          if (rule === undefined || rule === null) return;
          if (typeof rule === 'object' && rule.depends_on) {
            var depSelect = form.querySelector('[data-custom-option="' + rule.depends_on + '"]');
            var depValue  = depSelect ? depSelect.value : '';
            if (depValue && rule[depValue] !== undefined) {
              adjustment += rule[depValue];
            }
          } else if (typeof rule === 'number') {
            adjustment += rule;
          }
        } catch (err) {}
      });
      return adjustment;
    }

    function getProperties(form) {
      var props  = {};
      var inputs = Array.from(form.querySelectorAll('select[name^="properties["], input[name^="properties["]'));
      inputs.forEach(function (input) {
        var match = input.name.match(/^properties\[(.+)\]$/);
        if (match && input.value) {
          props[match[1]] = input.value;
        }
      });
      return Object.keys(props).length ? props : null;
    }

    function updateTotal(row, form) {
      var totalEl         = row.querySelector('.rh-product-row__total');
      var memberPriceEl   = totalEl && totalEl.querySelector('.rh-product-row__total-price--member');
      var regularPriceEl  = totalEl && totalEl.querySelector('.rh-product-row__total-price--regular');
      if (!totalEl || !memberPriceEl || !regularPriceEl) return;

      var hiddenInput = form.querySelector('.js-product-card-variant-input');
      var variantId   = hiddenInput && hiddenInput.value;
      if (!variantId) { hideTotal(row); return; }

      var qtySelect = row.querySelector('select[name="quantity"]');
      var qty       = qtySelect ? parseInt(qtySelect.value, 10) : 1;
      if (isNaN(qty) || qty < 0) qty = 0;
      if (qty === 0) { hideTotal(row); return; }

      var centsMapEl = row.querySelector('.rh-variant-cents');
      if (!centsMapEl) return;

      try {
        var centsMap   = JSON.parse(centsMapEl.textContent);
        var unitCents  = centsMap[String(variantId)];
        if (!unitCents) return;

        var adjustment   = getCustomOptionAdjustment(form) + getCustomOptionAddonCents(form);
        var totalCents   = (unitCents + adjustment) * qty;
        var memberCents  = Math.round(totalCents * getRowVipRate(row));
        memberPriceEl.textContent  = formatMoney(memberCents);
        regularPriceEl.textContent = formatMoney(totalCents);
        totalEl.style.display = '';
      } catch (err) {}
    }

    function updateOrderTotal(section) {
      if (!section) return;

      var orderTotalEl         = section.querySelector('.rh-order-total');
      var orderTotalMemberEl   = orderTotalEl && orderTotalEl.querySelector('.rh-order-total__price--member');
      var orderTotalRegularEl  = orderTotalEl && orderTotalEl.querySelector('.rh-order-total__price--regular');
      if (!orderTotalEl || !orderTotalMemberEl || !orderTotalRegularEl) return;

      var rows        = Array.from(section.querySelectorAll('.rh-product-row'));
      var grandTotal  = 0;
      var memberTotal = 0;
      var anySelected = false;

      rows.forEach(function (row) {
        var form        = row.querySelector('.rh-product-row__form');
        var hiddenInput = form && form.querySelector('.js-product-card-variant-input');
        var variantId   = hiddenInput && hiddenInput.value;
        if (!variantId) return;

        var qtySelect = row.querySelector('select[name="quantity"]');
        var qty       = qtySelect ? parseInt(qtySelect.value, 10) : 1;
        if (isNaN(qty) || qty < 0) qty = 0;
        if (qty === 0) return;

        var centsMapEl = row.querySelector('.rh-variant-cents');
        if (!centsMapEl) return;

        try {
          var centsMap  = JSON.parse(centsMapEl.textContent);
          var unitCents = centsMap[String(variantId)];
          if (!unitCents) return;

          var adjustment = getCustomOptionAdjustment(form) + getCustomOptionAddonCents(form);
          var rowTotal = (unitCents + adjustment) * qty;
          grandTotal  += rowTotal;
          memberTotal += Math.round(rowTotal * getRowVipRate(row));
          anySelected  = true;
        } catch (err) {}
      });

      if (anySelected) {
        orderTotalMemberEl.textContent  = formatMoney(memberTotal);
        orderTotalRegularEl.textContent = formatMoney(grandTotal);
        orderTotalEl.style.display      = '';
      } else {
        orderTotalEl.style.display = 'none';
      }
    }

    function hideTotal(row) {
      var totalEl = row && row.querySelector('.rh-product-row__total');
      if (totalEl) totalEl.style.display = 'none';
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = (window.Shopify.money_format || window.Shopify.money_with_currency_format || '${{amount}}');
        return window.Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // -------------------------------------------------------------------------
    // Lightbox
    // -------------------------------------------------------------------------

    var lbGallery = [];
    var lbIndex   = 0;

    function onImageClick(e) {
      var btn = e.target.closest('.rh-product-row__image-btn');
      if (btn) {
        var gallery = [];
        try { gallery = JSON.parse(btn.dataset.lightboxGallery || '[]'); } catch(err) {}
        if (!gallery.length) {
          gallery = [{ src: btn.dataset.lightboxSrc, alt: btn.dataset.lightboxAlt || '' }];
        }
        var currentSrc = btn.dataset.lightboxSrc;
        var startIndex = 0;
        for (var i = 0; i < gallery.length; i++) {
          if (gallery[i].src === currentSrc) { startIndex = i; break; }
        }
        openLightbox(gallery, startIndex);
        return;
      }
      if (e.target.closest('.rh-lightbox__close') || e.target.classList.contains('rh-lightbox__backdrop')) {
        closeLightbox();
      }
      if (e.target.closest('.rh-lightbox__prev')) { navigateLightbox(-1); }
      if (e.target.closest('.rh-lightbox__next')) { navigateLightbox(1); }
    }

    function openLightbox(gallery, index) {
      var lb      = document.getElementById('rh-lightbox');
      var img     = lb && lb.querySelector('.rh-lightbox__img');
      var counter = lb && lb.querySelector('.rh-lightbox__counter');
      var prevBtn = lb && lb.querySelector('.rh-lightbox__prev');
      var nextBtn = lb && lb.querySelector('.rh-lightbox__next');
      if (!lb || !img) return;
      lbGallery = gallery || [];
      lbIndex   = index   || 0;
      var entry = lbGallery[lbIndex] || {};
      img.src = entry.src || '';
      img.alt = entry.alt || '';
      if (counter) counter.textContent = lbGallery.length > 1 ? (lbIndex + 1) + ' / ' + lbGallery.length : '';
      if (prevBtn) { if (lbGallery.length <= 1) { prevBtn.setAttribute('hidden',''); } else { prevBtn.removeAttribute('hidden'); } }
      if (nextBtn) { if (lbGallery.length <= 1) { nextBtn.setAttribute('hidden',''); } else { nextBtn.removeAttribute('hidden'); } }
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function navigateLightbox(dir) {
      if (!lbGallery.length) return;
      lbIndex = (lbIndex + dir + lbGallery.length) % lbGallery.length;
      var lb      = document.getElementById('rh-lightbox');
      var img     = lb && lb.querySelector('.rh-lightbox__img');
      var counter = lb && lb.querySelector('.rh-lightbox__counter');
      if (!img) return;
      var entry = lbGallery[lbIndex] || {};
      img.src = entry.src || '';
      img.alt = entry.alt || '';
      if (counter) counter.textContent = (lbIndex + 1) + ' / ' + lbGallery.length;
    }

    function closeLightbox() {
      var lb = document.getElementById('rh-lightbox');
      if (!lb) return;
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
      lbGallery = [];
      lbIndex   = 0;
    }

    // -------------------------------------------------------------------------
    // Info modals (Details / Dimensions / Ask a Question)
    // -------------------------------------------------------------------------

    function onInfoTriggerClick(e) {
      var trigger = e.target.closest('.rh-info-trigger');
      if (!trigger) return;

      var type         = trigger.dataset.infoType;
      var productTitle = trigger.dataset.productTitle || '';
      var productUrl   = trigger.dataset.productUrl   || '';
      var row          = trigger.closest('.rh-product-row');

      if (type === 'details') {
        var el = row && row.querySelector('.rh-product-row__details-content');
        openInfoModal(productTitle, el ? el.innerHTML : '<p>No description available.</p>');
      } else if (type === 'dimensions') {
        var el = row && row.querySelector('.rh-product-row__dimensions-content');
        openInfoModal('Dimensions — ' + productTitle, el ? el.innerHTML : '<p>No dimensions available.</p>');
      } else if (type === 'ask') {
        openAskModal(productTitle, productUrl);
      }
    }

    function onModalClose(e) {
      if (e.target.closest('.rh-info-modal__close') || e.target.classList.contains('rh-info-modal__backdrop')) {
        closeInfoModal();
      }
      if (e.target.closest('.rh-ask-modal__close') || e.target.classList.contains('rh-ask-modal__backdrop')) {
        closeAskModal();
      }
      if (e.target.closest('.rh-swatch-modal__close') || e.target.classList.contains('rh-swatch-modal__backdrop')) {
        closeSwatchModal();
      }
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        closeLightbox();
        closeInfoModal();
        closeAskModal();
        closeSwatchModal();
      }
      var lb = document.getElementById('rh-lightbox');
      if (lb && !lb.hasAttribute('hidden')) {
        if (e.key === 'ArrowLeft')  { navigateLightbox(-1); }
        if (e.key === 'ArrowRight') { navigateLightbox(1); }
      }
    }

    // -------------------------------------------------------------------------
    // Swatch picker modal
    // -------------------------------------------------------------------------

    function onSwatchTriggerClick(e) {
      var trigger = e.target.closest('.rh-swatch-trigger');
      if (!trigger) return;
      activeSwatchTrigger = trigger;

      var optionName = trigger.dataset.optionName || 'Finish';
      var swatchData = [];
      try { swatchData = JSON.parse(trigger.dataset.swatchValues || '[]'); } catch (err) {}

      var currentValue = '';
      var row = trigger.closest('.rh-product-row');
      if (row) {
        var hiddenSel = row.querySelector('.rh-swatch-hidden-select[data-option="' + trigger.dataset.option + '"]');
        if (hiddenSel) currentValue = hiddenSel.value;
      }

      var modal   = document.getElementById('rh-swatch-modal');
      var titleEl = modal && modal.querySelector('.rh-swatch-modal__heading');
      var grid    = modal && modal.querySelector('.rh-swatch-modal__grid');
      if (!modal || !grid) return;

      if (titleEl) titleEl.textContent = 'Select ' + optionName;
      var noteEl = modal.querySelector('.rh-swatch-modal__note');
      if (noteEl) noteEl.hidden = !(optionName === 'Finish' || optionName === 'Seat');
      grid.classList.toggle('rh-swatch-modal__grid--shape', optionName === 'Table Shape');
      grid.classList.toggle('rh-swatch-modal__grid--leg', optionName === 'Leg Choice');
      grid.classList.toggle('rh-swatch-modal__grid--pedestal', optionName === 'Pedestal');
      grid.innerHTML = '';

      swatchData.forEach(function (swatch) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rh-swatch-item' + (swatch.value === currentValue ? ' rh-swatch-item--selected' : '');
        btn.dataset.value = swatch.value;

        var imgEl = document.createElement('img');
        imgEl.className = 'rh-swatch-item__img';
        imgEl.alt = swatch.value;
        imgEl.loading = 'lazy';
        imgEl.onerror = function () {
          var placeholder = document.createElement('div');
          placeholder.className = 'rh-swatch-item__img-placeholder';
          imgEl.parentNode && imgEl.parentNode.replaceChild(placeholder, imgEl);
        };
        imgEl.src = swatch.img;

        var labelEl = document.createElement('span');
        labelEl.className = 'rh-swatch-item__label';
        labelEl.textContent = swatch.value;

        var checkEl = document.createElement('span');
        checkEl.className = 'rh-swatch-item__check';
        checkEl.setAttribute('aria-hidden', 'true');
        checkEl.textContent = '✓';

        btn.appendChild(imgEl);
        btn.appendChild(labelEl);
        btn.appendChild(checkEl);
        grid.appendChild(btn);
      });

      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function onSwatchItemClick(e) {
      var item = e.target.closest('.rh-swatch-item');
      if (!item || !activeSwatchTrigger) return;

      var value = item.dataset.value;

      // Mark selected
      var grid = item.closest('.rh-swatch-modal__grid');
      if (grid) {
        Array.from(grid.querySelectorAll('.rh-swatch-item')).forEach(function (el) {
          el.classList.toggle('rh-swatch-item--selected', el === item);
        });
      }

      // Update the hidden select and fire change
      var row = activeSwatchTrigger.closest('.rh-product-row');
      if (row) {
        var hiddenSel = row.querySelector('.rh-swatch-hidden-select[data-option="' + activeSwatchTrigger.dataset.option + '"]');
        if (hiddenSel) {
          hiddenSel.value = value;
          hiddenSel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Update trigger button display
      var swatchData = [];
      try { swatchData = JSON.parse(activeSwatchTrigger.dataset.swatchValues || '[]'); } catch (err) {}
      var match = swatchData.find(function (s) { return s.value === value; });

      var swatchPreview = activeSwatchTrigger.querySelector('.rh-swatch-trigger__swatch');
      var labelEl       = activeSwatchTrigger.querySelector('.rh-swatch-trigger__label');
      if (swatchPreview) {
        swatchPreview.style.backgroundImage = match ? 'url(' + match.img + ')' : '';
        swatchPreview.removeAttribute('hidden');
      }
      if (labelEl) labelEl.textContent = value;

      // Immediately swap the product row image — only for Frame Style, not Finish/Color/etc.
      var swatchOptionName = activeSwatchTrigger ? (activeSwatchTrigger.dataset.optionName || '') : '';
      var isFrameOption = swatchOptionName === 'Frame Style' || swatchOptionName === 'Frame';
      if (isFrameOption && row && match && match.img) {
        var rowImgEl  = row.querySelector('.rh-product-row__image');
        var rowImgBtn = row.querySelector('.rh-product-row__image-btn');
        if (rowImgEl) rowImgEl.src = match.img;
        if (rowImgBtn) {
          var lbSrc = match.img.replace(/(\?|&)(width=)\d+/, function (m, sep, key) { return sep + key + '1400'; });
          rowImgBtn.dataset.lightboxSrc = lbSrc;
          rowImgBtn.dataset.lightboxAlt = value;
        }
      }

      // Finish sync: if the first row's Finish/Color changes, propagate to all other rows
      var isFinishOption = swatchOptionName === 'Finish' || swatchOptionName === 'Color';
      if (isFinishOption && row) {
        var section = row.closest('.rh-collection');
        var allRows = section ? Array.from(section.querySelectorAll('.rh-product-row')) : [];
        if (allRows.length > 0 && allRows[0] === row) {
          allRows.slice(1).forEach(function (otherRow) {
            syncFinishToRow(otherRow, value);
          });
        }
      }

      // Handles sync: if the first row that has handles changes, propagate to all other rows with handles
      var isHandlesOption = swatchOptionName === 'Handles' || swatchOptionName === 'Handle' || swatchOptionName === 'Handle Choice';
      if (isHandlesOption && row) {
        var hSection = row.closest('.rh-collection');
        var hAllRows = hSection ? Array.from(hSection.querySelectorAll('.rh-product-row')) : [];
        var firstHandlesRow = hAllRows.find(function (r) {
          return r.querySelector('select[data-option-name="Handles"], select[data-option-name="Handle"], select[data-option-name="Handle Choice"]');
        });
        if (firstHandlesRow === row) {
          hAllRows.forEach(function (otherRow) {
            if (otherRow !== row) syncHandlesToRow(otherRow, value);
          });
        }
      }

      // Close after brief delay so user sees the checkmark
      setTimeout(function () { closeSwatchModal(); }, 300);
    }

    function syncFinishToRow(row, value) {
      ['Finish', 'Color'].forEach(function (optName) {
        var sel = row.querySelector('select[data-option-name="' + optName + '"]');
        if (!sel) return;

        // Only apply if this finish value exists as an option in this product
        var exists = Array.from(sel.options).some(function (o) { return o.value === value; });
        if (!exists) return;

        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));

        // Update the swatch trigger button display
        var trigger = row.querySelector('.rh-swatch-trigger[data-option-name="' + optName + '"]');
        if (!trigger) return;

        var swatchData = [];
        try { swatchData = JSON.parse(trigger.dataset.swatchValues || '[]'); } catch (e) {}
        var match = swatchData.find(function (s) { return s.value === value; });

        var swatchEl = trigger.querySelector('.rh-swatch-trigger__swatch');
        var labelEl  = trigger.querySelector('.rh-swatch-trigger__label');
        if (swatchEl) {
          if (match && match.img) {
            swatchEl.style.backgroundImage = 'url(' + match.img + ')';
            swatchEl.removeAttribute('hidden');
          } else {
            swatchEl.style.backgroundImage = '';
          }
        }
        if (labelEl) labelEl.textContent = value;
      });
    }

    function syncHandlesToRow(row, value) {
      ['Handles', 'Handle', 'Handle Choice'].forEach(function (optName) {
        var sel = row.querySelector('select[data-option-name="' + optName + '"]');
        if (!sel) return;

        // Only apply if this handle value exists as an option in this product
        var exists = Array.from(sel.options).some(function (o) { return o.value === value; });
        if (!exists) return;

        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));

        // Update the swatch trigger button display
        var trigger = row.querySelector('.rh-swatch-trigger[data-option-name="' + optName + '"]');
        if (!trigger) return;

        var swatchData = [];
        try { swatchData = JSON.parse(trigger.dataset.swatchValues || '[]'); } catch (e) {}
        var match = swatchData.find(function (s) { return s.value === value; });

        var swatchEl = trigger.querySelector('.rh-swatch-trigger__swatch');
        var labelEl  = trigger.querySelector('.rh-swatch-trigger__label');
        if (swatchEl) {
          if (match && match.img) {
            swatchEl.style.backgroundImage = 'url(' + match.img + ')';
            swatchEl.removeAttribute('hidden');
          } else {
            swatchEl.style.backgroundImage = '';
          }
        }
        if (labelEl) labelEl.textContent = value;
      });
    }

    function closeSwatchModal() {
      var modal = document.getElementById('rh-swatch-modal');
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      activeSwatchTrigger = null;
    }

    function openInfoModal(title, content) {
      var modal   = document.getElementById('rh-info-modal');
      var titleEl = modal && modal.querySelector('.rh-info-modal__title');
      var bodyEl  = modal && modal.querySelector('.rh-info-modal__body');
      if (!modal) return;
      if (titleEl) titleEl.textContent = title;
      if (bodyEl)  bodyEl.innerHTML    = content;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeInfoModal() {
      var modal = document.getElementById('rh-info-modal');
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function openAskModal(productTitle, productUrl) {
      var modal     = document.getElementById('rh-ask-modal');
      var productEl = modal && modal.querySelector('.rh-ask-modal__product');
      var subjectEl = modal && modal.querySelector('.rh-ask-subject');
      var form      = modal && modal.querySelector('.rh-ask-form');
      var successEl = modal && modal.querySelector('.rh-ask-form__success');
      var errorEl   = modal && modal.querySelector('.rh-ask-form__error');
      if (!modal) return;

      if (form) form.reset();
      if (productEl) productEl.textContent = productTitle;
      if (subjectEl) subjectEl.value = 'Question about: ' + productTitle + (productUrl ? ' — ' + productUrl : '');
      if (successEl) successEl.setAttribute('hidden', '');
      if (errorEl)   errorEl.setAttribute('hidden', '');

      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeAskModal() {
      var modal = document.getElementById('rh-ask-modal');
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function onAskFormSubmit(e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.closest('#rh-ask-modal')) return;
      e.preventDefault();

      var submitBtn = form.querySelector('.rh-ask-form__submit');
      var successEl = form.querySelector('.rh-ask-form__success');
      var errorEl   = form.querySelector('.rh-ask-form__error');
      var nameEl    = form.querySelector('[name="contact[name]"]');
      var emailEl   = form.querySelector('[name="contact[email]"]');
      var bodyEl    = form.querySelector('[name="contact[body]"]');

      if (!nameEl || !nameEl.value.trim())                                   { if (nameEl)  nameEl.focus();  return; }
      if (!emailEl || !emailEl.value.trim() || !emailEl.value.includes('@')) { if (emailEl) emailEl.focus(); return; }
      if (!bodyEl  || !bodyEl.value.trim())                                  { if (bodyEl)  bodyEl.focus();  return; }

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }
      if (successEl) successEl.setAttribute('hidden', '');
      if (errorEl)   errorEl.setAttribute('hidden', '');

      // Fetch a fresh bot-protection token from Shopify's contact page, then POST
      fetch('/contact', { credentials: 'include' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc    = parser.parseFromString(html, 'text/html');
          var params = new URLSearchParams(new FormData(form));

          var contactForm = doc.querySelector('form[action*="/contact"]');
          if (contactForm) {
            contactForm.querySelectorAll('input[type="hidden"]').forEach(function (input) {
              if (!input.name) return;
              params.set(input.name, input.value);
            });
          }

          return fetch('/contact', {
            method:      'POST',
            credentials: 'include',
            headers:     { 'Content-Type': 'application/x-www-form-urlencoded' },
            body:        params.toString()
          });
        })
        .then(function (res) {
          if (res.status < 500) {
            if (successEl) successEl.removeAttribute('hidden');
            form.reset();
          } else {
            if (errorEl) errorEl.removeAttribute('hidden');
          }
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
        })
        .catch(function () {
          if (errorEl)   errorEl.removeAttribute('hidden');
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
        });
    }

    // -------------------------------------------------------------------------
    // Add all to cart (sticky bar)
    // -------------------------------------------------------------------------

    function fetchAddonVariantId(handle) {
      if (addonVariantCache[handle] !== undefined) {
        return Promise.resolve(addonVariantCache[handle]);
      }
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Not found');
          return res.json();
        })
        .then(function (product) {
          var id = product.variants && product.variants[0] && product.variants[0].id;
          addonVariantCache[handle] = id || null;
          return addonVariantCache[handle];
        })
        .catch(function () {
          addonVariantCache[handle] = null;
          return null;
        });
    }

    function buildAddonPromises(rows) {
      var promises = [];
      rows.forEach(function (row) {
        var form        = row.querySelector('.rh-product-row__form');
        var hiddenInput = form && form.querySelector('.js-product-card-variant-input');
        if (!hiddenInput || !hiddenInput.value) return;

        var drawerSelect = form.querySelector('[data-custom-option="Add Drawers Below Bed"]');
        if (!drawerSelect || drawerSelect.value !== 'Yes') return;

        var woodSelect  = form.querySelector('[data-custom-option="Wood"]');
        var wood        = woodSelect ? woodSelect.value : '';
        var isPineMaple = (wood === 'Rustic Pine' || wood === 'Wormy Maple');
        var handle      = isPineMaple
          ? drawerSelect.dataset.addonHandleA
          : drawerSelect.dataset.addonHandleB;
        if (!handle) return;

        var qtySelect = row.querySelector('select[name="quantity"]');
        var qty       = qtySelect ? parseInt(qtySelect.value, 10) : 1;
        if (isNaN(qty) || qty < 1) return;

        promises.push(
          fetchAddonVariantId(handle).then(function (variantId) {
            if (!variantId) return null;
            return { id: variantId, quantity: qty };
          })
        );
      });
      return promises;
    }

    function onAddAllClick(e) {
      var btn = e.target;
      if (!btn.matches || !btn.matches('.rh-order-total__add-all')) return;

      var section = btn.closest('.rh-collection');
      if (!section) return;

      var rows  = Array.from(section.querySelectorAll('.rh-product-row'));
      var items = [];

      rows.forEach(function (row) {
        var form        = row.querySelector('.rh-product-row__form');
        var hiddenInput = form && form.querySelector('.js-product-card-variant-input');
        var variantId   = hiddenInput && hiddenInput.value;
        if (!variantId) return;

        var qtySelect = row.querySelector('select[name="quantity"]');
        var qty       = qtySelect ? parseInt(qtySelect.value, 10) : 1;
        if (isNaN(qty) || qty < 1) return;

        var item  = { id: parseInt(variantId, 10), quantity: qty };
        var props = getProperties(form);
        if (props) item.properties = props;
        items.push(item);
      });

      if (!items.length) return;

      btn.disabled    = true;
      btn.textContent = 'Adding...';
      btn.classList.add('rh-order-total__add-all--loading');

      Promise.all(buildAddonPromises(rows))
        .then(function (addonItems) {
          addonItems.forEach(function (addonItem) {
            if (addonItem) items.push(addonItem);
          });
          return fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body:    JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added to Cart!';
          btn.classList.remove('rh-order-total__add-all--loading');

          if (window.themeCore && window.themeCore.CartApi) {
            window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
          }

          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var els = document.querySelectorAll('[data-cart-count], .js-cart-count, .cart-count, .header__cart-count');
              els.forEach(function (el) { el.textContent = cart.item_count; });
            })
            .catch(function () {});

          setTimeout(function () {
            btn.disabled    = false;
            btn.textContent = 'Add Current Selections To Cart';
          }, 2500);
        })
        .catch(function () {
          btn.classList.remove('rh-order-total__add-all--loading');
          btn.disabled    = false;
          btn.textContent = 'Try Again';
          setTimeout(function () {
            btn.textContent = 'Add Current Selections To Cart';
          }, 2500);
        });
    }

    // -------------------------------------------------------------------------
    // Individual product form submit (safety handler — no individual ATC button)
    // -------------------------------------------------------------------------

    function onFormSubmit(e) {
      var form = e.target;
      if (!form.matches || !form.matches('.rh-product-row__form')) return;
      e.preventDefault();

      var hiddenInput = form.querySelector('.js-product-card-variant-input');
      var variantId   = hiddenInput && hiddenInput.value;
      if (!variantId) return;

      var formRow   = form.closest('.rh-product-row');
      var qtySelect = formRow ? formRow.querySelector('select[name="quantity"]') : form.querySelector('select[name="quantity"]');
      var quantity  = qtySelect ? parseInt(qtySelect.value, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;

      var item  = { id: parseInt(variantId, 10), quantity: quantity };
      var props = getProperties(form);
      if (props) item.properties = props;

      if (window.themeCore && window.themeCore.CartApi) {
        window.themeCore.CartApi.makeRequest(
          window.themeCore.CartApi.actions.ADD_TO_CART, item
        ).then(function () {
          onAddSuccess(null);
        }).catch(function () {
          onAddError(null);
        });
      } else {
        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify(item)
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () { onAddSuccess(null); })
        .catch(function () { onAddError(null); });
      }
    }

    function onAddSuccess(button) {
      if (button) { button.textContent = 'ADDED!'; }
      if (window.themeCore && window.themeCore.CartApi) {
        window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
      }
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var els = document.querySelectorAll('[data-cart-count], .js-cart-count, .cart-count, .header__cart-count');
          els.forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () {});
      setTimeout(function () {
        if (button) { button.disabled = false; button.textContent = 'ADD TO CART'; }
      }, 2000);
    }

    function onAddError(button) {
      if (button) { button.disabled = false; button.textContent = 'TRY AGAIN'; }
      setTimeout(function () {
        if (button) { button.textContent = 'ADD TO CART'; }
      }, 2000);
    }

    return Object.freeze({ init: init });
  };

  function setup() {
    var instance = RHCollectionProducts();
    instance.init();
    applyRefCollection();
  }

  function applyRefCollection() {
    var ref = new URLSearchParams(window.location.search).get('ref');
    if (!ref) return;

    // Update "View complete collection" link
    var link = document.querySelector('.rh-view-collection__link');
    if (link) link.href = '/collections/' + ref;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }


  // Member info modal
  document.addEventListener('click', function (e) {
    var modal = document.getElementById('rh-member-info-modal');
    if (!modal) return;
    if (e.target.closest('.rh-member-info-btn')) {
      modal.removeAttribute('hidden');
      return;
    }
    if (e.target.closest('.rh-member-info-modal__close') || e.target.closest('.rh-member-info-modal__backdrop')) {
      modal.setAttribute('hidden', '');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('rh-member-info-modal');
      if (modal) modal.setAttribute('hidden', '');
    }
  });

})();
